"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearAuth = clearAuth;
exports.loadAuth = loadAuth;
exports.saveAuth = saveAuth;
exports.updateAuth = updateAuth;
var AUTH_KEY = "user";
var STORAGE_TYPE_KEY = "auth_storage_type";
/**
 * Saves auth data to the appropriate storage based on rememberMe preference.
 * - rememberMe = true → localStorage (persists across browser close)
 * - rememberMe = false → sessionStorage (clears when tab/browser closes, survives refresh)
 */
function saveAuth(data, rememberMe) {
    var json = JSON.stringify(data);
    if (rememberMe) {
        localStorage.setItem(AUTH_KEY, json);
        localStorage.setItem(STORAGE_TYPE_KEY, "local");
        // Clear sessionStorage to avoid stale data
        sessionStorage.removeItem(AUTH_KEY);
    }
    else {
        sessionStorage.setItem(AUTH_KEY, json);
        sessionStorage.setItem(STORAGE_TYPE_KEY, "session");
        // Clear localStorage to avoid stale data
        localStorage.removeItem(AUTH_KEY);
    }
}
/**
 * Loads auth data from whichever storage has it.
 * Checks localStorage first (rememberMe), then sessionStorage.
 */
function loadAuth() {
    var local = localStorage.getItem(AUTH_KEY);
    if (local) {
        try {
            return JSON.parse(local);
        }
        catch (_a) {
            localStorage.removeItem(AUTH_KEY);
        }
    }
    var session = sessionStorage.getItem(AUTH_KEY);
    if (session) {
        try {
            return JSON.parse(session);
        }
        catch (_b) {
            sessionStorage.removeItem(AUTH_KEY);
        }
    }
    return null;
}
/**
 * Updates the auth data in whichever storage is currently active
 * (e.g. after a token refresh).
 */
function updateAuth(data) {
    var storageType = localStorage.getItem(STORAGE_TYPE_KEY) || sessionStorage.getItem(STORAGE_TYPE_KEY);
    var json = JSON.stringify(data);
    if (storageType === "local") {
        localStorage.setItem(AUTH_KEY, json);
    }
    else {
        sessionStorage.setItem(AUTH_KEY, json);
    }
}
/**
 * Clears auth data from all storages.
 */
function clearAuth() {
    localStorage.removeItem(AUTH_KEY);
    localStorage.removeItem(STORAGE_TYPE_KEY);
    sessionStorage.removeItem(AUTH_KEY);
    sessionStorage.removeItem(STORAGE_TYPE_KEY);
}
